$(".notifications").one("dropdown:shown", () => {
  $(".bell_start, .bell_middle").remove()
  $(".bell_finish").removeClass("hidden")

  RailsRequest.post("/user/notification_read_at")
})

$(".notifications").on("click", ".notifications--i_unread", function (e) {
  $(this).removeClass("notifications--i_unread")
})

setTimeout(() => {
  $(".bell_start").remove()
  $(".bell_middle").removeClass("hidden")
}, 5000)
